import { render, staticRenderFns } from "./billing-plot.vue?vue&type=template&id=0d84f2fa&"
import script from "./billing-plot.vue?vue&type=script&lang=js&"
export * from "./billing-plot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports